import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSouthSudan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1739)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.0639 7.3478C21.2466 3.03103 16.9776 0 12 0C8.68624 0 5.68657 1.34339 3.51514 3.51511L6.52029 7.3478H23.0639Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.55437 16.6088L3.51514 20.4849C5.68657 22.6566 8.68624 24 12 24C16.9944 24 21.2755 20.9487 23.0824 16.6088H6.55437Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.60864 8.82608V15.1304H23.5866C23.8558 14.1324 23.9999 13.0831 23.9999 12C23.9999 10.9011 23.8519 9.83708 23.5752 8.82608H2.60864Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51471 3.51468C-1.17157 8.20096 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51468Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.90877 9.01651L5.37338 11.0603L7.77001 10.2988L6.27887 12.3235L7.74348 14.3674L5.35716 13.5749L3.86597 15.5995L3.88238 13.085L1.49597 12.2924L3.89241 11.5309L3.90877 9.01651Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1739",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSouthSudan;
